import React, { createContext, useContext } from 'react';

import { ROUTE_SCANBAT } from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import {
  NodesContextProviderDefaultProps,
  NodesContextProviderPropTypes,
} from '@/common/contexts/NodesTreeContext/NodesTreeContextProvider.proptypes';
import useNodesTree from '@/common/hooks/nodes/useNodesTree';

const NodesTreeContext = createContext(null);

const NodesTreeContextProvider = ({ children, depth }) => {
  const { isLoggedIn } = useAuth();
  const isScanbat = window.location.pathname.includes(ROUTE_SCANBAT);
  const { data, isSuccess, isLoading } = useNodesTree({
    depth,
    disabled: !isLoggedIn || isScanbat,
  });

  return (
    <NodesTreeContext.Provider
      value={{
        isSuccess,
        isLoading,
        nodesTree: data,
      }}
    >
      {children}
    </NodesTreeContext.Provider>
  );
};

NodesTreeContextProvider.defaultProps = {
  ...NodesContextProviderDefaultProps,
};

NodesTreeContextProvider.propTypes = {
  ...NodesContextProviderPropTypes,
};

export const useNodesTreeContext = () => useContext(NodesTreeContext);

export default NodesTreeContextProvider;
